import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { Profile, Protocol, Staking } from '@tokenlon/sdk';
import { MARKET_API_BASE_URL, RAILS_API_BASE_URL, AUTH_TOKEN, axios, rpc } from "../common";
export * from "./types";
export var PROTOCOLS = [Protocol.AMMV1, Protocol.AMMV2, Protocol.RFQV2, Protocol.RFQV1];
export var getGasPrice = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", rpc.post("/ethereum", {
              id: 1,
              jsonrpc: '2.0',
              method: 'wallet.getFeeGears',
              params: []
            }, {
              headers: {
                Authorization: "JWT ".concat(AUTH_TOKEN),
                'X-DEVICE-TOKEN': 'tokenlon-web'
              }
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getGasPrice() {
    return _ref.apply(this, arguments);
  };
}(); // 传递进 getTradeTokenList 和 getRateOrOrder 的 quoter 必须是同一个对象

export var getTradeTokenList = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(quoter) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (quoter) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            return _context2.abrupt("return", quoter.getTradeTokenList(PROTOCOLS));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getTradeTokenList(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var getRateOrOrder = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(quoter, address, _ref3, setRate, setOrder, lock) {
    var base, quote, side, amount, sendByRelayer;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            base = _ref3.base, quote = _ref3.quote, side = _ref3.side, amount = _ref3.amount, sendByRelayer = _ref3.sendByRelayer;
            if (quoter !== null && quoter !== void 0 && quoter.unsubscribeAll) quoter === null || quoter === void 0 ? void 0 : quoter.unsubscribeAll();

            if (!(!quoter || !base || !quote || !side || lock)) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return");

          case 4:
            if (quoter.isConnected()) {
              _context3.next = 7;
              break;
            }

            _context3.next = 7;
            return quoter.connect(AUTH_TOKEN);

          case 7:
            setRate(); // 预备重新拿订单了，之前兑率和订单数据失效了，所以重置一下

            setOrder(); // amout 为 0 时走 quoter.getRate

            if (address && Number(amount)) {
              if (quoter.setSignerAddress) quoter.setSignerAddress(address);
              quoter.trueRate({
                base: base,
                quote: quote,
                side: side,
                amount: amount,
                protocols: PROTOCOLS,
                sendByRelayer: sendByRelayer
              }, function (error, topic, message, subscription) {
                setOrder({
                  error: error,
                  topic: topic,
                  message: message,
                  subscription: subscription
                });
              });
            } else {
              quoter.getRate({
                base: base,
                quote: quote,
                side: side,
                sendByRelayer: sendByRelayer
              }, function (error, topic, message, subscription) {
                setRate({
                  error: error,
                  topic: topic,
                  message: message,
                  subscription: subscription
                });
              });
            }

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getRateOrOrder(_x2, _x3, _x4, _x5, _x6, _x7) {
    return _ref4.apply(this, arguments);
  };
}();
export var getOrderState = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(provider, executeTxHash) {
    var profile;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!provider || !executeTxHash)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return");

          case 2:
            profile = new Profile(provider);
            return _context4.abrupt("return", profile.getOrderState(executeTxHash));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getOrderState(_x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}();
export var getLonPoolOverview = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", axios.get("/referral/pool"));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getLonPoolOverview() {
    return _ref6.apply(this, arguments);
  };
}();
export var getAddressShare = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(address) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (address) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt("return");

          case 2:
            return _context6.abrupt("return", axios.get("/referral/pool/shares?address=".concat(address)));

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getAddressShare(_x10) {
    return _ref7.apply(this, arguments);
  };
}();
export var getGenesisReward = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(address) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (address) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return");

          case 2:
            return _context7.abrupt("return", axios.get("lon-edge/accounts/".concat(address, "/claims?status=unclaim")));

          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getGenesisReward(_x11) {
    return _ref8.apply(this, arguments);
  };
}();
export var getTokenLinePrices = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(token, start, end, interval) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", rpc.post("/market", {
              id: 1,
              jsonrpc: '2.0',
              method: 'klines.getLinePrices',
              params: {
                interval: interval,
                slug: token,
                start: start,
                end: end
              }
            }));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getTokenLinePrices(_x12, _x13, _x14, _x15) {
    return _ref9.apply(this, arguments);
  };
}();
export var getLonBalance = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(provider, address) {
    var profile;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!(!provider || !address)) {
              _context9.next = 2;
              break;
            }

            return _context9.abrupt("return");

          case 2:
            profile = new Profile(provider);
            return _context9.abrupt("return", profile.getLonBalance(address));

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function getLonBalance(_x16, _x17) {
    return _ref10.apply(this, arguments);
  };
}();
export var getXLonBalance = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(provider, address) {
    var profile;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!(!provider || !address)) {
              _context10.next = 2;
              break;
            }

            return _context10.abrupt("return");

          case 2:
            profile = new Profile(provider);
            return _context10.abrupt("return", profile.getXLonBalanceByAddr(address));

          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function getXLonBalance(_x18, _x19) {
    return _ref11.apply(this, arguments);
  };
}();
export var getTokenBalance = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(provider, address, tokenAddress) {
    var profile;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!(!provider || !address || !tokenAddress)) {
              _context11.next = 2;
              break;
            }

            return _context11.abrupt("return");

          case 2:
            profile = new Profile(provider);
            return _context11.abrupt("return", profile.getTokenBalance(tokenAddress, address));

          case 4:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function getTokenBalance(_x20, _x21, _x22) {
    return _ref12.apply(this, arguments);
  };
}(); // 获取 LON 和 xLon 的兑换比

export var getXLonScaleIndex = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(chainId, _ref13) {
    var end, start, staking;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            end = _ref13.end, start = _ref13.start;

            if (chainId) {
              _context12.next = 3;
              break;
            }

            return _context12.abrupt("return");

          case 3:
            staking = new Staking(chainId);
            return _context12.abrupt("return", staking.fetchXLon2LonScaleIndex(start, end));

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function getXLonScaleIndex(_x23, _x24) {
    return _ref14.apply(this, arguments);
  };
}();
export var getSushiLonPriceRate = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt("return", rpc.post("", {
              id: 1,
              jsonrpc: '2.0',
              method: 'api.getMarketPrice',
              params: {
                base: 'SUSHI',
                quote: 'LON',
                baseAmount: 0.000001
              }
            }, {
              baseURL: MARKET_API_BASE_URL
            }));

          case 1:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function getSushiLonPriceRate() {
    return _ref15.apply(this, arguments);
  };
}();
export var getMarketPriceHistoryChartLine = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(days, baseSymbol, quoteSymbol) {
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt("return", rpc.post("", {
              id: 1,
              jsonrpc: '2.0',
              method: 'api.getMarketPriceHistoryChartLine',
              params: {
                market: 'tokenlon',
                baseSymbol: baseSymbol,
                quoteSymbol: quoteSymbol,
                days: days
              }
            }, {
              baseURL: MARKET_API_BASE_URL
            }));

          case 1:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function getMarketPriceHistoryChartLine(_x25, _x26, _x27) {
    return _ref16.apply(this, arguments);
  };
}();
export var getMarketPriceHistoryChartCandle = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(days, baseSymbol, quoteSymbol) {
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt("return", rpc.post("", {
              id: 1,
              jsonrpc: '2.0',
              method: 'api.getMarketPriceHistoryChartCandle',
              params: {
                market: 'tokenlon',
                baseSymbol: baseSymbol,
                quoteSymbol: quoteSymbol,
                days: days
              }
            }, {
              baseURL: MARKET_API_BASE_URL
            }));

          case 1:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function getMarketPriceHistoryChartCandle(_x28, _x29, _x30) {
    return _ref17.apply(this, arguments);
  };
}();
export var getIsDisableTradeByIP = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    var _res$features, res, isDisableTrade;

    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            _context16.next = 3;
            return rpc.post("", {
              id: 1,
              jsonrpc: '2.0',
              method: 'configuration.getGlobal'
            }, {
              baseURL: RAILS_API_BASE_URL,
              headers: {
                'X-CLIENT-VERSION': 'tokenlonweb:1.0.0'
              }
            });

          case 3:
            res = _context16.sent;
            isDisableTrade = res === null || res === void 0 || (_res$features = res.features) === null || _res$features === void 0 || (_res$features = _res$features.MarketTab) === null || _res$features === void 0 || (_res$features = _res$features.Trade) === null || _res$features === void 0 ? void 0 : _res$features.disabled;
            return _context16.abrupt("return", isDisableTrade);

          case 8:
            _context16.prev = 8;
            _context16.t0 = _context16["catch"](0);
            return _context16.abrupt("return", false);

          case 11:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[0, 8]]);
  }));

  return function getIsDisableTradeByIP() {
    return _ref18.apply(this, arguments);
  };
}();